import { render, staticRenderFns } from "./ContractsTable.vue?vue&type=template&id=6ce75120&scoped=true&"
import script from "./ContractsTable.vue?vue&type=script&lang=ts&"
export * from "./ContractsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ContractsTable.vue?vue&type=style&index=0&id=6ce75120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce75120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
